import React from 'react'
import Skeleton from 'react-loading-skeleton'

import FormattedPrice from 'src/shared/components/common/price/FormattedPrice'

import DiscountedPrice from './DiscountedPrice'
import { DiscountsInfoToolTip } from './DiscountsToolTip'
import classNames from 'classnames'

export type ItemPriceProps = {
  loading: boolean
  title: string | React.ReactNode
  amount?: number | null
  negative?: boolean
  amountPrefix?: string
  enableTooltip?: boolean
  shippingMessage?: string
  className?: string
  // Struck through beside `amount` when set.
  originalAmount?: number
  testId?: string
}

const ItemPrice = ({
  loading,
  title,
  amount,
  negative,
  amountPrefix = '',
  enableTooltip = true,
  shippingMessage,
  className,
  originalAmount,
  testId
}: ItemPriceProps) => {
  if (amount === undefined || amount === null) {
    return null
  }
  // make negative if not already and let the formatter properly format negative currency
  const normalizedAmount = negative && amount > 0 ? amount * -1 : amount

  const isDiscounts = title === 'Discounts'
  // Striking through a price that is not higher would read as a mistake. Both
  // amounts come in unsigned, so compare before `negative` flips the sign.
  const isDiscounted = originalAmount !== undefined && originalAmount > amount
  return (
    <div
      data-testid={testId ?? `${title}-item-test-id`}
      className={classNames('cart-flex-row', className)}
    >
      {loading ? (
        <>
          <div className='titleAndTooltip'>
            <Skeleton width={80} containerTestId='title-loading-skeleton' />
          </div>
          <Skeleton width={40} containerTestId='price-loading-skeleton' />
        </>
      ) : (
        <>
          <div className='titleAndTooltip'>
            <span data-testid={'item-price-title'}>{title}</span>
            {/* We do not want to show the tooltip or certain pages (i.e. the confirmation page) */}
            {isDiscounts && enableTooltip && <DiscountsInfoToolTip />}
          </div>
          {shippingMessage ? (
            <span data-testid={'item-price-amount'}>{shippingMessage}</span>
          ) : isDiscounted ? (
            <DiscountedPrice
              originalAmount={originalAmount}
              amount={normalizedAmount}
              amountPrefix={amountPrefix}
              testIdPrefix='item-price'
            />
          ) : (
            <span data-testid={'item-price-amount'}>
              {amountPrefix}
              {<FormattedPrice value={normalizedAmount} />}
            </span>
          )}
        </>
      )}
    </div>
  )
}

export default ItemPrice
